'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const Chart = dynamic(() => import('./StatusChartInner'), { ssr: false });

export default function StatusChart({ data }: { data: { status: string; count: number; amount: number }[] }) {
  return <Chart data-component-id="src/app/dashboard/components/StatusChart.tsx:8:9" data-component-path="src/app/dashboard/components/StatusChart.tsx" data-component-line="8" data-component-end-line="8" data-component-file="StatusChart.tsx" data-component-name="Chart" data-component-content="%7B%22elementName%22%3A%22Chart%22%7D" data={data} />;
}